module.exports = __webpack_public_path__ + "img/3_82.deedbd7a.png";